import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { Paper, Typography, MenuItem, Checkbox, ListItemText, Grid, Button, TableContainer, Table,
// TableHead,
// TableRow,
// TableCell,
TableBody,
// Accordion,
// AccordionSummary,
// AccordionDetails,
// List,
// ListItem,
ListSubheader } from '@mui/material';
import { SelectMenu,
// DatePicker,
Icon, TableLoader, BackdropLoader } from '@livable/saas-react-components';
import Row from './tableRow';
import { useTranslation } from 'react-i18next';
import warningImg from 'src/img/warning.svg';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import moment from 'moment/moment';
import { TRANSACTION_TYPES, TRANSACTION_TYPESV2 } from 'src/constants/payments';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import SendReportModal from 'src/pages/ARPage/SendReportModal';
import BarChartPaidUnpaid from './charts/BarChartPaidUnpaid';
import PieChartUnpaid from './charts/PieChartUnpaid';
import PieChartPaid from './charts/PieChartPaid';
import { generateAddressString } from 'src/utils/address';
import { isValueNumber } from 'src/utils/typeValidators';
export const ReimbursementTab = observer(() => {
  var _getARReportData;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    companyProperties = _useState4[0],
    setCompanyProperties = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    companyReport = _useState6[0],
    setCompanyReport = _useState6[1];
  const reportPeriodsEnum = {
    year: 'year',
    quarters: 'quarters',
    months: 'months'
  };
  const reportPeriodsNamesEnum = {
    year: 'Annually',
    quarters: 'Quarter',
    months: 'Monthly'
  };
  const _useState7 = useState(reportPeriodsEnum.months),
    _useState8 = _slicedToArray(_useState7, 2),
    reportPeriod = _useState8[0],
    setReportPeriod = _useState8[1];
  const getPropertyById = id => {
    return companyProperties[id];
  };
  const getCompanyPropertyList = async () => {
    const resp = await store.company.getCompanyPropertyListAsync.run();
    if (resp && resp.isSuccessful) {
      setCompanyProperties(resp.response.reduce((previousValue, currentValue) => {
        return Object.assign({}, previousValue, {
          [currentValue.propertyId]: currentValue
        });
      }, {}));
    }
    return resp;
  };
  const getCompanyTeamMembers = async () => {
    const resp = await store.teamMembers.getCompanyTeamMembersAsync.run({
      companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
    });
    return resp;
  };
  const reimbursementFilterOptionsEnum = {
    propertyOptions: 'propertyOptions',
    unitOptions: 'unitOptions',
    periodOptions: 'periodOptions',
    chargeOptions: 'chargeOptions'
  };
  const _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    propertyOptions = _useState0[0],
    setPropertyOptions = _useState0[1];
  const _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    unitOptions = _useState10[0],
    setUnitOptions = _useState10[1];
  const _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    chargeOptions = _useState12[0],
    setChargeOptions = _useState12[1];
  const _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    periodOptions = _useState14[0],
    setPeriodOptions = _useState14[1];
  const isDisabled = isLoading || store.report.downloadCombinedPropertiesReportAsync.inProgress || !Array.from(new Set(companyReport.map(i => i.propertyId))).length;
  const getReimbursementFiltersV2 = async () => {
    const reimbursementFiltersResp = await store.report.getReimbursementAsync.run({});
    if (reimbursementFiltersResp && reimbursementFiltersResp !== null && reimbursementFiltersResp !== void 0 && reimbursementFiltersResp.isSuccessful) {
      const response = reimbursementFiltersResp.response;
      const finalRes = Object.entries(reimbursementFilterOptionsEnum).reduce((previousValue, currentValue) => {
        const result = _objectSpread({}, previousValue);
        const _currentValue = _slicedToArray(currentValue, 1),
          key = _currentValue[0];
        switch (key) {
          case reimbursementFilterOptionsEnum.propertyOptions:
            {
              setPropertyOptions(response[key].map(i => {
                return _objectSpread(_objectSpread({}, i), {}, {
                  isChosen: true
                });
              }));
              result[key] = response[key].map(i => {
                return _objectSpread(_objectSpread({}, i), {}, {
                  isChosen: true
                });
              });
              break;
            }
          case reimbursementFilterOptionsEnum.unitOptions:
            {
              setUnitOptions(response[key].map(i => {
                return _objectSpread(_objectSpread({}, i), {}, {
                  isChosen: true
                });
              }));
              result[key] = response[key].map(i => {
                return _objectSpread(_objectSpread({}, i), {}, {
                  isChosen: true
                });
              });
              break;
            }
          case reimbursementFilterOptionsEnum.periodOptions:
            {
              const periods = response[key].reduce((acc, value) => {
                var _value$months, _value$quarters;
                const resultPeriod = [...acc];
                resultPeriod.push({
                  months: (_value$months = value.months) === null || _value$months === void 0 ? void 0 : _value$months.map(i => {
                    return {
                      id: "".concat(value.year, "-M-").concat(i),
                      year: value.year,
                      name: moment().year(value.year).month(i - 1).format('MMMM'),
                      value: i,
                      isChosen: true
                    };
                  }),
                  quarters: (_value$quarters = value.quarters) === null || _value$quarters === void 0 ? void 0 : _value$quarters.map(i => {
                    return {
                      id: "".concat(value.year, "-Y-").concat(i),
                      year: value.year,
                      name: i,
                      value: i,
                      isChosen: true
                    };
                  }),
                  year: value.year,
                  id: "".concat(value.year, "-YEAR"),
                  isChosen: true
                });
                return resultPeriod;
              }, []);
              setPeriodOptions(periods.map(i => {
                return _objectSpread(_objectSpread({}, i), {}, {
                  isChosen: true
                });
              }));
              result[key] = periods.map(i => {
                return _objectSpread(_objectSpread({}, i), {}, {
                  isChosen: true
                });
              });
              break;
            }
          case reimbursementFilterOptionsEnum.chargeOptions:
            {
              setChargeOptions(response[key].map(i => {
                return _objectSpread(_objectSpread({}, i), {}, {
                  isChosen: true
                });
              }));
              result[key] = response[key].map(i => {
                return _objectSpread(_objectSpread({}, i), {}, {
                  isChosen: true
                });
              });
              break;
            }
        }
        return result;
      }, {});
      return finalRes;
    }
  };
  const getPropertyReport = async _ref => {
    let propertyIds = _ref.propertyIds;
    const resp = await store.report.getPropertiesReportsAsync.run(propertyIds);
    if (resp && resp.isSuccessful) {
      var _resp$response;
      setCompanyReport((_resp$response = resp.response) === null || _resp$response === void 0 || (_resp$response = _resp$response.data) === null || _resp$response === void 0 ? void 0 : _resp$response.map(i => i));
    }
    return resp;
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    totalReimbursementReportData = _useState16[0],
    setTotalReimbursementReportData = _useState16[1];
  const _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    barChartData = _useState18[0],
    setBarChartData = _useState18[1];
  const _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    paidPieChartData = _useState20[0],
    setPaidPieChartData = _useState20[1];
  const _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    unpaidPieChartData = _useState22[0],
    setUnpaidPieChartData = _useState22[1];
  const getChartsData = async function () {
    let _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$propertyOptions = _ref2.propertyOptionsExt,
      propertyOptionsExt = _ref2$propertyOptions === void 0 ? undefined : _ref2$propertyOptions,
      _ref2$unitOptionsExt = _ref2.unitOptionsExt,
      unitOptionsExt = _ref2$unitOptionsExt === void 0 ? undefined : _ref2$unitOptionsExt,
      _ref2$periodOptionsEx = _ref2.periodOptionsExt,
      periodOptionsExt = _ref2$periodOptionsEx === void 0 ? undefined : _ref2$periodOptionsEx,
      _ref2$chargeOptionsEx = _ref2.chargeOptionsExt,
      chargeOptionsExt = _ref2$chargeOptionsEx === void 0 ? undefined : _ref2$chargeOptionsEx,
      _ref2$reportPeriodExt = _ref2.reportPeriodExt,
      reportPeriodExt = _ref2$reportPeriodExt === void 0 ? undefined : _ref2$reportPeriodExt;
    setIsLoading(true);
    const propertyOptionsQuery = propertyOptionsExt !== null && propertyOptionsExt !== void 0 ? propertyOptionsExt : propertyOptions;
    const unitOptionsQuery = unitOptionsExt !== null && unitOptionsExt !== void 0 ? unitOptionsExt : unitOptions;
    const periodOptionsQuery = periodOptionsExt !== null && periodOptionsExt !== void 0 ? periodOptionsExt : periodOptions;
    const chargeOptionsQuery = chargeOptionsExt !== null && chargeOptionsExt !== void 0 ? chargeOptionsExt : chargeOptions;
    const query = {};
    if (propertyOptionsQuery.length && propertyOptionsQuery.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).length) {
      query.propertyIds = propertyOptionsQuery.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).map(property => property === null || property === void 0 ? void 0 : property.propertyId);
    }
    if (unitOptionsQuery.length && unitOptionsQuery.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).length) {
      query.unitIds = unitOptionsQuery.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).map(unit => unit === null || unit === void 0 ? void 0 : unit.unitId);
    }
    query.period = reportPeriodExt ? reportPeriodsNamesEnum[reportPeriodExt] : reportPeriodsNamesEnum[reportPeriod];
    if (periodOptionsQuery.length && periodOptionsQuery.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).length) {
      var _query$selectedPeriod;
      query.selectedPeriods = periodOptionsQuery.map(period => {
        const result = {
          year: period === null || period === void 0 ? void 0 : period.year,
          months: [],
          quarters: []
        };
        if (reportPeriod === reportPeriodsEnum.months) result.months = period === null || period === void 0 ? void 0 : period.months.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).map(month => month.value);
        if (reportPeriod === reportPeriodsEnum.quarters) {
          result.quarters = period === null || period === void 0 ? void 0 : period.quarters.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).map(quarter => Number(quarter === null || quarter === void 0 ? void 0 : quarter.value.substring(1)) - 1);
        }
        if (reportPeriod !== reportPeriodsEnum.year && !result.months.length && !result.quarters.length) {
          return undefined;
        }
        return result;
      }).filter(i => i !== undefined);
      if (!(query !== null && query !== void 0 && (_query$selectedPeriod = query.selectedPeriods) !== null && _query$selectedPeriod !== void 0 && _query$selectedPeriod.length)) query === null || query === void 0 || delete query.selectedPeriods;
    }
    if (chargeOptionsQuery.length && chargeOptionsQuery.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).length) {
      query.selectedChargeTypes = chargeOptionsQuery.filter(i => i === null || i === void 0 ? void 0 : i.isChosen).map(chargeType => {
        return {
          utilityTypeId: chargeType === null || chargeType === void 0 ? void 0 : chargeType.utilityTypeId,
          chargeType: chargeType === null || chargeType === void 0 ? void 0 : chargeType.chargeType
        };
      });
    }
    const reimbursementGraphsResp = await store.report.getReimbursementReportAsync.run(_objectSpread({}, query));
    if (reimbursementGraphsResp !== null && reimbursementGraphsResp !== void 0 && reimbursementGraphsResp.isSuccessful && !!(reimbursementGraphsResp !== null && reimbursementGraphsResp !== void 0 && reimbursementGraphsResp.response)) {
      var _reimbursementGraphsR;
      const periodType = reimbursementGraphsResp.response.dataByPeriod.periodType;
      const periodHandler = _ref3 => {
        let periodTypeHandler = _ref3.periodTypeHandler,
          period = _ref3.period,
          format = _ref3.format;
        switch (periodTypeHandler) {
          case reportPeriodsNamesEnum.months:
            {
              return format !== undefined && format === 'full' ? moment().month(period - 1).format('MMMM') : moment().month(period - 1).format('MMM');
            }
          case reportPeriodsNamesEnum.year:
            {
              return moment().year(period).format('YYYY');
            }
          case reportPeriodsNamesEnum.quarters:
            {
              return "Q".concat(Number(period) + 1);
            }
        }
      };
      const dataByPeriod = (_reimbursementGraphsR = reimbursementGraphsResp.response.dataByPeriod) === null || _reimbursementGraphsR === void 0 || (_reimbursementGraphsR = _reimbursementGraphsR.data) === null || _reimbursementGraphsR === void 0 ? void 0 : _reimbursementGraphsR.reduce((previousValue, currentValue) => {
        if ((isValueNumber(currentValue === null || currentValue === void 0 ? void 0 : currentValue.period) || currentValue !== null && currentValue !== void 0 && currentValue.period) && (currentValue === null || currentValue === void 0 ? void 0 : currentValue.period) !== null) {
          var _currentValue$year;
          currentValue.periodName = periodHandler({
            periodTypeHandler: periodType,
            period: currentValue.period
          });
          currentValue.periodFullName = periodHandler({
            periodTypeHandler: periodType,
            period: currentValue.period,
            format: 'full'
          }) + " ".concat(currentValue.year);
          currentValue.year = (_currentValue$year = currentValue.year) !== null && _currentValue$year !== void 0 ? _currentValue$year : 'YYYY';
        } else {
          currentValue.periodName = currentValue.year;
          currentValue.periodFullName = currentValue.year;
        }
        return [...previousValue, _objectSpread({}, currentValue)];
      }, []).sort((a, b) => {
        return moment(reportPeriodExt === reportPeriodsEnum.quarters ? moment(a.year, 'YYYY').quarter(Number(a.period) + 1).startOf('quarter').toDate() : a.periodFullName).diff(moment(reportPeriodExt === reportPeriodsEnum.quarters ? moment(b.year, 'YYYY').quarter(Number(b.period) + 1).startOf('quarter').toDate() : b.periodFullName), reportPeriodExt === reportPeriodsEnum.year ? 'year' : reportPeriodExt === reportPeriodsEnum.quarters ? 'quarter' : 'month');
      });
      const dataByType = reimbursementGraphsResp.response.dataByType.data;
      setTotalReimbursementReportData({
        totalCredited: reimbursementGraphsResp.response.totalCredited,
        totalCreditedPercentage: reimbursementGraphsResp.response.totalCreditedPercentage,
        totalPaid: reimbursementGraphsResp.response.totalPaid,
        totalPaidPercentage: reimbursementGraphsResp.response.totalPaidPercentage,
        totalUnpaid: reimbursementGraphsResp.response.totalUnpaid,
        totalUnpaidPercentage: reimbursementGraphsResp.response.totalUnpaidPercentage
      });
      setBarChartData(dataByPeriod);
      setPaidPieChartData(dataByType.filter(i => i.paid !== 0).map(i => {
        return _objectSpread({
          name: i.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? i.utilityTypeName : i.chargeType,
          value: i.paid
        }, i);
      }));
      setUnpaidPieChartData(dataByType.filter(i => i.unpaid !== 0).map(i => {
        return _objectSpread({
          name: i.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? i.utilityTypeName : i.chargeType,
          value: i.unpaid
        }, i);
      }));
    } else {
      setTotalReimbursementReportData(null);
      setBarChartData(null);
      setPaidPieChartData(null);
      setUnpaidPieChartData(null);
    }
    setIsLoading(false);
  };
  const updateFilterSelectionValueV2 = _ref4 => {
    let filterName = _ref4.filterName,
      valueId = _ref4.valueId;
    const isFilterSelectAll = valueId === 'select-all';
    const fetchQuery = {
      propertyOptionsExt: propertyOptions,
      unitOptionsExt: unitOptions,
      periodOptionsExt: periodOptions,
      chargeOptionsExt: chargeOptions
    };
    switch (filterName) {
      case reimbursementFilterOptionsEnum.propertyOptions:
        {
          var _fetchQuery$propertyO2;
          if (isFilterSelectAll) {
            var _propertyOptions$filt, _fetchQuery$propertyO;
            const isUnSelectedExists = !!(propertyOptions !== null && propertyOptions !== void 0 && (_propertyOptions$filt = propertyOptions.filter(i => !i.isChosen)) !== null && _propertyOptions$filt !== void 0 && _propertyOptions$filt.length);
            setPropertyOptions(propertyOptions.map(i => {
              return _objectSpread(_objectSpread({}, i), {}, {
                isChosen: isUnSelectedExists
              });
            }));
            fetchQuery.propertyOptionsExt = propertyOptions.map(i => {
              return _objectSpread(_objectSpread({}, i), {}, {
                isChosen: isUnSelectedExists
              });
            });
            getPropertyReport({
              propertyIds: (_fetchQuery$propertyO = fetchQuery.propertyOptionsExt) === null || _fetchQuery$propertyO === void 0 ? void 0 : _fetchQuery$propertyO.filter(i => i.isChosen).map(i => i.propertyId)
            });
            break;
          }
          const result = [...propertyOptions];
          const toUpdateIndex = propertyOptions.findIndex(i => i.propertyId === valueId);
          result[toUpdateIndex].isChosen = !result[toUpdateIndex].isChosen;
          setPropertyOptions(result);
          fetchQuery.propertyOptionsExt = result;
          getPropertyReport({
            propertyIds: (_fetchQuery$propertyO2 = fetchQuery.propertyOptionsExt) === null || _fetchQuery$propertyO2 === void 0 ? void 0 : _fetchQuery$propertyO2.filter(i => i.isChosen).map(i => i.propertyId)
          });
          break;
        }
      case reimbursementFilterOptionsEnum.unitOptions:
        {
          if (isFilterSelectAll) {
            var _unitOptions$filter;
            const isUnSelectedExists = !!(unitOptions !== null && unitOptions !== void 0 && (_unitOptions$filter = unitOptions.filter(i => !i.isChosen)) !== null && _unitOptions$filter !== void 0 && _unitOptions$filter.length);
            setUnitOptions(unitOptions.map(i => {
              return _objectSpread(_objectSpread({}, i), {}, {
                isChosen: isUnSelectedExists
              });
            }));
            fetchQuery.unitOptionsExt = unitOptions.map(i => {
              return _objectSpread(_objectSpread({}, i), {}, {
                isChosen: isUnSelectedExists
              });
            });
            break;
          }
          const result = [...unitOptions];
          const toUpdateIndex = unitOptions.findIndex(i => i.unitId === valueId);
          result[toUpdateIndex].isChosen = !result[toUpdateIndex].isChosen;
          setUnitOptions(result);
          fetchQuery.unitOptionsExt = result;
          break;
        }
      case reimbursementFilterOptionsEnum.periodOptions:
        {
          if (isFilterSelectAll) {
            const result = [...periodOptions];
            switch (reportPeriod) {
              case reportPeriodsEnum.months:
                {
                  var _periodOptions$map;
                  const isUnSelectedExists = !!((_periodOptions$map = periodOptions.map(year => year[reportPeriodsEnum.months])) !== null && _periodOptions$map !== void 0 && (_periodOptions$map = _periodOptions$map.flat().filter(i => !i.isChosen)) !== null && _periodOptions$map !== void 0 && _periodOptions$map.length);
                  result.forEach((year, yearIndex) => {
                    result[yearIndex][reportPeriodsEnum.months].forEach((month, monthIndex) => {
                      result[yearIndex][reportPeriodsEnum.months][monthIndex].isChosen = isUnSelectedExists;
                    });
                  });
                  break;
                }
              case reportPeriodsEnum.quarters:
                {
                  var _periodOptions$map2;
                  const isUnSelectedExists = !!((_periodOptions$map2 = periodOptions.map(year => year[reportPeriodsEnum.quarters])) !== null && _periodOptions$map2 !== void 0 && (_periodOptions$map2 = _periodOptions$map2.flat().filter(i => !i.isChosen)) !== null && _periodOptions$map2 !== void 0 && _periodOptions$map2.length);
                  result.forEach((year, yearIndex) => {
                    result[yearIndex][reportPeriodsEnum.quarters].forEach((quarter, quarterIndex) => {
                      result[yearIndex][reportPeriodsEnum.quarters][quarterIndex].isChosen = isUnSelectedExists;
                    });
                  });
                  break;
                }
              case reportPeriodsEnum.year:
                {
                  var _periodOptions$filter;
                  const isUnSelectedExists = !!(periodOptions !== null && periodOptions !== void 0 && (_periodOptions$filter = periodOptions.filter(year => !year.isChosen)) !== null && _periodOptions$filter !== void 0 && _periodOptions$filter.length);
                  result.forEach((i, index) => {
                    result[index].isChosen = isUnSelectedExists;
                  });
                  break;
                }
            }
            setPeriodOptions(result);
            fetchQuery.periodOptionsExt = result;
            break;
          }
          const result = [...periodOptions];
          switch (reportPeriod) {
            case reportPeriodsEnum.months:
              {
                const yearOptionIndex = result.findIndex(i => i.year === valueId.year);
                const monthOptionIndex = result[yearOptionIndex][reportPeriodsEnum.months].findIndex(i => i.year === valueId.year && i.value === valueId.value);
                result[yearOptionIndex][reportPeriodsEnum.months][monthOptionIndex].isChosen = !result[yearOptionIndex][reportPeriodsEnum.months][monthOptionIndex].isChosen;
                break;
              }
            case reportPeriodsEnum.quarters:
              {
                const yearOptionIndex = result.findIndex(i => i.year === valueId.year);
                const quarterOptionIndex = result[yearOptionIndex][reportPeriodsEnum.quarters].findIndex(i => i.year === valueId.year && i.value === valueId.value);
                result[yearOptionIndex][reportPeriodsEnum.quarters][quarterOptionIndex].isChosen = !result[yearOptionIndex][reportPeriodsEnum.quarters][quarterOptionIndex].isChosen;
                break;
              }
            case reportPeriodsEnum.year:
              {
                const yearOptionIndex = result.findIndex(i => i.year === valueId.year);
                result[yearOptionIndex].isChosen = !result[yearOptionIndex].isChosen;
                break;
              }
          }
          setPeriodOptions(result);
          fetchQuery.periodOptionsExt = result;
          break;
        }
      case reimbursementFilterOptionsEnum.chargeOptions:
        {
          if (isFilterSelectAll) {
            var _chargeOptions$filter;
            const isUnSelectedExists = !!(chargeOptions !== null && chargeOptions !== void 0 && (_chargeOptions$filter = chargeOptions.filter(i => !i.isChosen)) !== null && _chargeOptions$filter !== void 0 && _chargeOptions$filter.length);
            setChargeOptions(chargeOptions.map(i => {
              return _objectSpread(_objectSpread({}, i), {}, {
                isChosen: isUnSelectedExists
              });
            }));
            fetchQuery.chargeOptionsExt = chargeOptions.map(i => {
              return _objectSpread(_objectSpread({}, i), {}, {
                isChosen: isUnSelectedExists
              });
            });
            break;
          }
          const result = [...chargeOptions];
          const toUpdateIndex = chargeOptions.findIndex(i => i.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? i.utilityTypeId === valueId : i.chargeType === valueId);
          result[toUpdateIndex].isChosen = !result[toUpdateIndex].isChosen;
          setChargeOptions(result);
          fetchQuery.chargeOptionsExt = result;
          break;
        }
    }
    getChartsData(fetchQuery);
  };
  const GetActivePeriods = _ref5 => {
    let reportPeriodExt = _ref5.reportPeriodExt;
    if (!periodOptions) return;
    let result;
    switch (reportPeriodExt) {
      case reportPeriodsEnum.months:
        {
          result = periodOptions.sort((a, b) => a.year - b.year).map(period => {
            var _period$months$sort;
            return (_period$months$sort = period.months.sort((a, b) => a.value - b.value)) === null || _period$months$sort === void 0 ? void 0 : _period$months$sort.map(i => {
              return /*#__PURE__*/React.createElement(MenuItem, {
                key: i.id,
                value: i.value,
                variant: "multiple",
                onClick: () => {
                  updateFilterSelectionValueV2({
                    filterName: reimbursementFilterOptionsEnum.periodOptions,
                    valueId: i
                  });
                }
              }, /*#__PURE__*/React.createElement(Checkbox, {
                checked: i.isChosen
              }), /*#__PURE__*/React.createElement(ListItemText, null, "".concat(i.name, " ").concat(i.year)));
            });
          });
          // .flat();
          break;
        }
      case reportPeriodsEnum.quarters:
        {
          result = periodOptions === null || periodOptions === void 0 ? void 0 : periodOptions.sort((a, b) => a.year - b.year).map(period => {
            var _period$reportPeriods;
            return (_period$reportPeriods = period[reportPeriodsEnum.quarters]) === null || _period$reportPeriods === void 0 || (_period$reportPeriods = _period$reportPeriods.sort((a, b) => Number(a.value.substring(1)) - Number(b.value.substring(1)))) === null || _period$reportPeriods === void 0 ? void 0 : _period$reportPeriods.map(i => {
              return /*#__PURE__*/React.createElement(MenuItem, {
                key: i.id,
                value: i.value,
                variant: "multiple"
                // disabled={i.disabled}
                ,
                onClick: () => {
                  updateFilterSelectionValueV2({
                    filterName: reimbursementFilterOptionsEnum.periodOptions,
                    valueId: i
                  });
                }
              }, /*#__PURE__*/React.createElement(Checkbox, {
                checked: i.isChosen
                // disabled={i.disabled}
              }), /*#__PURE__*/React.createElement(ListItemText, null, "".concat(i.name, " ").concat(i.year)));
            });
          });
          // .flat();
          break;
        }
      case reportPeriodsEnum.year:
        {
          result = periodOptions === null || periodOptions === void 0 ? void 0 : periodOptions.map(i => {
            return /*#__PURE__*/React.createElement(MenuItem, {
              key: i.id,
              value: i.year,
              variant: "multiple"
              // disabled={i.disabled}
              ,
              onClick: () => {
                updateFilterSelectionValueV2({
                  filterName: reimbursementFilterOptionsEnum.periodOptions,
                  valueId: i
                });
              }
            }, /*#__PURE__*/React.createElement(Checkbox, {
              checked: i.isChosen
              // disabled={i.disabled}
            }), /*#__PURE__*/React.createElement(ListItemText, null, i.year));
          });
          break;
        }
    }
    return result;
  };
  const getFilterSelectedV2 = _ref6 => {
    let filterName = _ref6.filterName,
      labelKey = _ref6.labelKey,
      _ref6$labelKey = _ref6.labelKey2,
      labelKey2 = _ref6$labelKey === void 0 ? undefined : _ref6$labelKey;
    switch (filterName) {
      case reimbursementFilterOptionsEnum.propertyOptions:
        {
          const chosenItems = propertyOptions.filter(i => i.isChosen) || [];
          if ((chosenItems === null || chosenItems === void 0 ? void 0 : chosenItems.length) === 0) return [];
          const resultOptions = chosenItems.map(i => i[labelKey]);
          return (resultOptions === null || resultOptions === void 0 ? void 0 : resultOptions.length) === 0 ? [] : resultOptions;
        }
      case reimbursementFilterOptionsEnum.unitOptions:
        {
          const chosenItems = unitOptions.filter(i => i.isChosen) || [];
          if ((chosenItems === null || chosenItems === void 0 ? void 0 : chosenItems.length) === 0) return [];
          const resultOptions = chosenItems.map(i => i[labelKey]);
          return (resultOptions === null || resultOptions === void 0 ? void 0 : resultOptions.length) === 0 ? [] : resultOptions;
        }
      case reimbursementFilterOptionsEnum.periodOptions:
        {
          switch (reportPeriod) {
            case reportPeriodsEnum.months:
              {
                return periodOptions.map(year => year[reportPeriodsEnum.months].filter(month => month.isChosen)).flat();
              }
            case reportPeriodsEnum.quarters:
              {
                return periodOptions.map(year => year[reportPeriodsEnum.quarters].filter(quarter => quarter.isChosen)).flat();
              }
            case reportPeriodsEnum.year:
              {
                return periodOptions.filter(year => year.isChosen);
              }
          }
          break;
        }
      case reimbursementFilterOptionsEnum.chargeOptions:
        {
          const chosenItems = chargeOptions.filter(i => i.isChosen) || [];
          if ((chosenItems === null || chosenItems === void 0 ? void 0 : chosenItems.length) === 0) return [];
          const resultOptions = chosenItems.map(i => i[i.chargeType === TRANSACTION_TYPESV2.UtilityCharge && !!labelKey2 ? labelKey2 : labelKey]);
          return (resultOptions === null || resultOptions === void 0 ? void 0 : resultOptions.length) === 0 ? [] : resultOptions;
        }
    }
  };
  const getIsSelectedAllV2 = _ref7 => {
    let filterName = _ref7.filterName;
    switch (filterName) {
      case reimbursementFilterOptionsEnum.propertyOptions:
        {
          return propertyOptions.filter(i => !(i !== null && i !== void 0 && i.isChosen)).length;
        }
      case reimbursementFilterOptionsEnum.unitOptions:
        {
          return unitOptions.filter(i => !(i !== null && i !== void 0 && i.isChosen)).length;
        }
      case reimbursementFilterOptionsEnum.periodOptions:
        {
          switch (reportPeriod) {
            case reportPeriodsEnum.months:
              {
                var _periodOptions$map3;
                return (_periodOptions$map3 = periodOptions.map(year => year[reportPeriodsEnum.months])) === null || _periodOptions$map3 === void 0 || (_periodOptions$map3 = _periodOptions$map3.flat().filter(month => !month.isChosen)) === null || _periodOptions$map3 === void 0 ? void 0 : _periodOptions$map3.length;
              }
            case reportPeriodsEnum.quarters:
              {
                var _periodOptions$map4;
                return (_periodOptions$map4 = periodOptions.map(year => year[reportPeriodsEnum.quarters])) === null || _periodOptions$map4 === void 0 || (_periodOptions$map4 = _periodOptions$map4.flat().filter(quarter => !quarter.isChosen)) === null || _periodOptions$map4 === void 0 ? void 0 : _periodOptions$map4.length;
              }
            case reportPeriodsEnum.year:
              {
                var _periodOptions$filter2;
                return periodOptions === null || periodOptions === void 0 || (_periodOptions$filter2 = periodOptions.filter(year => !year.isChosen)) === null || _periodOptions$filter2 === void 0 ? void 0 : _periodOptions$filter2.length;
              }
          }
          break;
        }
      case reimbursementFilterOptionsEnum.chargeOptions:
        {
          return chargeOptions.filter(i => !(i !== null && i !== void 0 && i.isChosen)).length;
        }
    }
  };
  const getARReportData = () => {
    if (!companyReport || !companyReport.length) return;
    const arData = {};
    companyReport.forEach(resident => {
      var _arData$resident$prop, _arData$resident$prop2, _arData$resident$prop3;
      const residentItem = _objectSpread(_objectSpread({}, resident), {}, {
        residentFullName: resident.residentFullName,
        total: resident.total,
        currentPeriod: resident.currentPeriod,
        dayMonthPeriod: resident.dayMonthPeriod,
        oneMonthTwoMonthPeriod: resident.oneMonthTwoMonthPeriod,
        twoMonthThreeMonthPeriod: resident.twoMonthThreeMonthPeriod,
        moreThreeMonthPeriod: resident.moreThreeMonthPeriod,
        phone: resident.phone,
        unitName: resident.unitName,
        emailAddress: resident.emailAddress,
        propertyId: resident.propertyId,
        accountId: resident.accountId
      });
      arData[resident.propertyId] = {
        propertyId: resident.propertyId,
        residents: (_arData$resident$prop = arData[resident.propertyId]) !== null && _arData$resident$prop !== void 0 && _arData$resident$prop.residents && (_arData$resident$prop2 = arData[resident.propertyId]) !== null && _arData$resident$prop2 !== void 0 && (_arData$resident$prop2 = _arData$resident$prop2.residents) !== null && _arData$resident$prop2 !== void 0 && _arData$resident$prop2.length ? [...((_arData$resident$prop3 = arData[resident.propertyId]) === null || _arData$resident$prop3 === void 0 ? void 0 : _arData$resident$prop3.residents), residentItem] : [residentItem]
      };
    });
    Object.keys(arData).forEach(key => {
      arData[key] = Object.assign({}, arData[key], getPropertyById(key));
    });
    return Object.entries(arData).map(_ref8 => {
      let _ref9 = _slicedToArray(_ref8, 2),
        key = _ref9[0],
        value = _ref9[1];
      return /*#__PURE__*/React.createElement(Row, {
        key: key,
        data: value
      });
    });
  };
  const handleDownloadBatchReport = async (e, propertyIds) => {
    e.stopPropagation();
    const getFileName = headers => {
      var _headers$fileName;
      return (_headers$fileName = headers['file-name']) !== null && _headers$fileName !== void 0 ? _headers$fileName : null;
    };
    const _await$store$report$d = await store.report.downloadCombinedPropertiesReportAsync.run({
        propertyIds: propertyIds
      }),
      downloadedFile = _await$store$report$d.data,
      headers = _await$store$report$d.headers;
    const encodedUri = window.URL.createObjectURL(new Blob([downloadedFile], {
      type: 'application/octet-stream'
    }));
    let link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', getFileName(headers));
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
  useEffect(() => {
    setIsLoading(true);
    Promise.all([getCompanyPropertyList(), getCompanyTeamMembers()]).then(async responses => {
      var _responses$;
      await Promise.all([getReimbursementFiltersV2().then(async resp => {
        await getChartsData({
          propertyOptionsExt: resp[reimbursementFilterOptionsEnum.propertyOptions],
          unitOptionsExt: resp[reimbursementFilterOptionsEnum.unitOptions],
          periodOptionsExt: resp[reimbursementFilterOptionsEnum.periodOptions],
          chargeOptionsExt: resp[reimbursementFilterOptionsEnum.chargeOptions]
        });
      }), getPropertyReport({
        propertyIds: (_responses$ = responses[0]) === null || _responses$ === void 0 || (_responses$ = _responses$.response) === null || _responses$ === void 0 ? void 0 : _responses$.map(i => i.propertyId)
      })]);
    }).finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, t('reimbursement_dashboard.reimbursement_dashboard')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('reimbursement_dashboard.reimbursement_dashboard_desc'))), /*#__PURE__*/React.createElement("div", {
    className: classes.selectors
  }, /*#__PURE__*/React.createElement(Paper, {
    variant: "evenBasicSmall"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mdSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "property-selector",
    value: getFilterSelectedV2({
      filterName: reimbursementFilterOptionsEnum.propertyOptions,
      filterSelectedKey: 'propertyId',
      labelKey: 'propertyName'
    }) || 'all-properties',
    label: t('reimbursement_dashboard.property'),
    labelId: "property-selector-label",
    multiple: true
    // enableSearch
    ,
    onChange: event => updateFilterSelectionValueV2({
      filterName: reimbursementFilterOptionsEnum.propertyOptions,
      valueId: event.target.value[event.target.value.length - 1]
    }),
    renderValue: selected => {
      return !getIsSelectedAllV2({
        filterName: reimbursementFilterOptionsEnum.propertyOptions
      }) ? t('reimbursement_dashboard.all_properties') : selected.join(', ');
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    key: "select-all",
    value: 'select-all',
    variant: "multiple"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: !getIsSelectedAllV2({
      filterName: reimbursementFilterOptionsEnum.propertyOptions
    })
  }), /*#__PURE__*/React.createElement(ListItemText, null, t('reimbursement_dashboard.all_properties'))), propertyOptions.length && propertyOptions.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    key: i.propertyId,
    value: i.propertyId,
    variant: "multiple"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: i.isChosen
  }), /*#__PURE__*/React.createElement(ListItemText, null, i === null || i === void 0 ? void 0 : i.propertyName))))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "unit-selector",
    key: "unit-selector",
    value: getFilterSelectedV2({
      filterName: reimbursementFilterOptionsEnum.unitOptions,
      labelKey: 'unitName'
    }),
    label: t('reimbursement_dashboard.unit'),
    labelId: "unit-selector-label",
    multiple: true
    // enableSearch
    ,
    onChange: event => {
      updateFilterSelectionValueV2({
        filterName: reimbursementFilterOptionsEnum.unitOptions,
        valueId: event.target.value[event.target.value.length - 1]
      });
    },
    renderValue: selected => {
      return !getIsSelectedAllV2({
        filterName: reimbursementFilterOptionsEnum.unitOptions
      }) ? t('reimbursement_dashboard.all_units') : selected.join(', ');
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    key: "select-all",
    value: 'select-all',
    variant: "multiple"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: !getIsSelectedAllV2({
      filterName: reimbursementFilterOptionsEnum.unitOptions
    })
  }), /*#__PURE__*/React.createElement(ListItemText, null, t('reimbursement_dashboard.all_units'))), !!unitOptions.length && unitOptions.sort((a, b) => {
    var _ref0;
    return (_ref0 = '' + (a === null || a === void 0 ? void 0 : a.propertyId)) === null || _ref0 === void 0 ? void 0 : _ref0.localeCompare(b === null || b === void 0 ? void 0 : b.propertyId, undefined, {
      numeric: true
    });
  }).filter(unitOption => propertyOptions.find(property => property.propertyId === unitOption.propertyId).isChosen).map((i, index, array) => {
    var _array;
    if (index === 0 || ((_array = array[index - 1]) === null || _array === void 0 ? void 0 : _array.propertyId) !== i.propertyId) {
      return [/*#__PURE__*/React.createElement(ListSubheader, {
        key: 'unit-selector-property' + i.propertyId
      }, generateAddressString(getPropertyById(i.propertyId).address)), /*#__PURE__*/React.createElement(MenuItem, {
        key: i.unitId,
        value: i.unitId,
        variant: "multiple"
        // disabled={i.disabled}
      }, /*#__PURE__*/React.createElement(Checkbox, {
        checked: i.isChosen,
        disabled: i.disabled
      }), /*#__PURE__*/React.createElement(ListItemText, null, i.unitName))];
    }
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: i.unitId,
      value: i.unitId,
      variant: "multiple"
      // disabled={i.disabled}
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: i.isChosen,
      disabled: i.disabled
    }), /*#__PURE__*/React.createElement(ListItemText, null, i.unitName));
  }).flat())), /*#__PURE__*/React.createElement("div", {
    className: classes.smSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "billing-cycles-selector",
    value: reportPeriod,
    label: t('reimbursement_dashboard.billing_cycle'),
    labelId: "billing-cycles-selector-label"
    // disabled
    ,
    onChange: event => {
      var _event$target, _event$target2;
      setReportPeriod((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
      getChartsData({
        reportPeriodExt: (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value
      });
    }
  }, Object.entries(reportPeriodsNamesEnum).map(_ref1 => {
    let _ref10 = _slicedToArray(_ref1, 2),
      key = _ref10[0],
      value = _ref10[1];
    return /*#__PURE__*/React.createElement(MenuItem, {
      value: key
    }, value);
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "billing-periods-selector",
    value: getFilterSelectedV2({
      filterName: reimbursementFilterOptionsEnum.periodOptions,
      labelKey: undefined
    }),
    label: t('reimbursement_dashboard.period'),
    labelId: "billing-periods-selector",
    renderValue: () => {
      return !getIsSelectedAllV2({
        filterName: reimbursementFilterOptionsEnum.periodOptions
      }) ? t('reimbursement_dashboard.all_periods') : getFilterSelectedV2({
        filterName: reimbursementFilterOptionsEnum.periodOptions,
        labelKey: undefined
      }).map(i => i !== null && i !== void 0 && i.name ? "".concat(i.name, " ").concat(i.year) : "".concat(i.year)).join(', ');
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    key: "select-all",
    value: 'select-all',
    variant: "multiple",
    onClick: () => {
      updateFilterSelectionValueV2({
        filterName: reimbursementFilterOptionsEnum.periodOptions,
        valueId: 'select-all'
      });
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: !getIsSelectedAllV2({
      filterName: reimbursementFilterOptionsEnum.periodOptions
    })
  }), /*#__PURE__*/React.createElement(ListItemText, null, t('reimbursement_dashboard.all_periods'))), /*#__PURE__*/React.createElement(GetActivePeriods, {
    reportPeriodExt: reportPeriod
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "charges-selector",
    value: getFilterSelectedV2({
      filterName: reimbursementFilterOptionsEnum.chargeOptions,
      labelKey: 'chargeType',
      labelKey2: 'utilityTypeName'
    }),
    label: t('reimbursement_dashboard.charges'),
    labelId: "charges-selector-label",
    multiple: true
    // enableSearch
    ,
    renderValue: () => {
      return !getIsSelectedAllV2({
        filterName: reimbursementFilterOptionsEnum.chargeOptions
      }) ? t('reimbursement_dashboard.all_charges') : getFilterSelectedV2({
        filterName: reimbursementFilterOptionsEnum.chargeOptions,
        labelKey: 'chargeType',
        labelKey2: 'utilityTypeName'
      }).join(', ');
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    key: "select-all",
    value: 'select-all',
    variant: "multiple",
    onClick: () => {
      updateFilterSelectionValueV2({
        filterName: reimbursementFilterOptionsEnum.chargeOptions,
        valueId: 'select-all'
      });
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: !getIsSelectedAllV2({
      filterName: reimbursementFilterOptionsEnum.chargeOptions
    })
  }), /*#__PURE__*/React.createElement(ListItemText, null, t('reimbursement_dashboard.all_charges'))), !!chargeOptions.length && chargeOptions.map(i => /*#__PURE__*/React.createElement(MenuItem, {
    key: i.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? i.utilityTypeId : i.chargeType,
    value: i.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? i.utilityTypeId : i.chargeType,
    variant: "multiple",
    onClick: () => {
      updateFilterSelectionValueV2({
        filterName: reimbursementFilterOptionsEnum.chargeOptions,
        valueId: i.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? i.utilityTypeId : i.chargeType
      });
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: i.isChosen
  }), /*#__PURE__*/React.createElement(ListItemText, null, i.chargeType === TRANSACTION_TYPESV2.UtilityCharge ? i === null || i === void 0 ? void 0 : i.utilityTypeName : TRANSACTION_TYPES[i.chargeType])))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 10,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sm: barChartData !== null && (barChartData === null || barChartData === void 0 ? void 0 : barChartData.length) > 6 ? 12 : 4
  }, /*#__PURE__*/React.createElement(Paper, {
    key: 'BarChartPaidUnpaidCredited'
  }, barChartData === null || !(barChartData !== null && barChartData !== void 0 && barChartData.length) ? /*#__PURE__*/React.createElement("div", {
    className: classes.emptyPlaceholderSingleChart
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chartHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: "p"
  }, t('reimbursement_dashboard.no_data_charts'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Combined Chart Paid Unpaid Credited missing data",
    src: warningImg,
    height: '170px',
    width: '300px'
  }))) : /*#__PURE__*/React.createElement("div", {
    className: classes.chartContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chartHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('reimbursement_dashboard.paid_unpaid_credited'))), /*#__PURE__*/React.createElement("div", {
    className: classes.chartContent
  }, /*#__PURE__*/React.createElement(BarChartPaidUnpaid, {
    data: barChartData
  }))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sm: barChartData !== null && (barChartData === null || barChartData === void 0 ? void 0 : barChartData.length) > 6 ? 6 : 4
  }, /*#__PURE__*/React.createElement(Paper, {
    key: 'PieChartPaid'
  }, paidPieChartData === null || !(paidPieChartData !== null && paidPieChartData !== void 0 && paidPieChartData.length) ? /*#__PURE__*/React.createElement("div", {
    className: classes.emptyPlaceholderSingleChart
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chartHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: "p"
  }, t('reimbursement_dashboard.no_data_charts'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Chart Paid missing data",
    src: warningImg,
    height: '170px',
    width: '300px'
  }))) : /*#__PURE__*/React.createElement("div", {
    className: classes.chartContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chartHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: 'span'
  }, t('reimbursement_dashboard.paid')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    component: 'span'
  }, t('reimbursement_dashboard.total_paid', {
    totalPaid: "$".concat(Number(totalReimbursementReportData.totalPaid).toFixed(2))
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.chartContent
  }, /*#__PURE__*/React.createElement(PieChartPaid, {
    data: paidPieChartData
  }))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sm: barChartData !== null && (barChartData === null || barChartData === void 0 ? void 0 : barChartData.length) > 6 ? 6 : 4
  }, /*#__PURE__*/React.createElement(Paper, {
    key: 'PieChartUnpaid'
  }, unpaidPieChartData === null || !(unpaidPieChartData !== null && unpaidPieChartData !== void 0 && unpaidPieChartData.length) ? /*#__PURE__*/React.createElement("div", {
    className: classes.emptyPlaceholderSingleChart
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chartHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: "p"
  }, t('reimbursement_dashboard.no_data_charts'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Chart Unpaid missing data",
    src: warningImg,
    height: '170px',
    width: '300px'
  }))) : /*#__PURE__*/React.createElement("div", {
    className: classes.chartContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chartHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('reimbursement_dashboard.unpaid')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    component: 'span'
  }, t('reimbursement_dashboard.total_unpaid', {
    totalUnpaid: "$".concat(Number(totalReimbursementReportData.totalUnpaid).toFixed(2))
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.chartContent
  }, /*#__PURE__*/React.createElement(PieChartUnpaid, {
    data: unpaidPieChartData
  }))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('reimbursement_dashboard.ar_report')), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 10,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: isDisabled,
    onClick: e => handleDownloadBatchReport(e, Array.from(new Set(companyReport.map(i => i.propertyId)))),
    variant: "action",
    'custom-attribute': '788-reporting-page-reimbursement-tab'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-download"
  }), t('reimbursement_dashboard.download_report'))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(SendReportModal, {
    disabled: isDisabled,
    properties: propertyOptions.filter(i => i.isChosen) || [],
    variant: "action"
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(TableContainer, {
    className: classes.tableContainer
  }, isLoading ? /*#__PURE__*/React.createElement(TableLoader, null) : /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableBody, null, getARReportData()))), !isLoading && !((_getARReportData = getARReportData()) !== null && _getARReportData !== void 0 && _getARReportData.length) && /*#__PURE__*/React.createElement("div", {
    className: classes.emptyPlaceholder
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('reimbursement_dashboard.no_data')), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement("img", {
    alt: "warning image",
    src: warningImg,
    height: "338",
    width: "407"
  })))))));
});